/**
 * Элемент аккордеона FAQ / Maintenance (02_GPT-MODULAR).
 */

import "./AccordionItem.css";

const ARROW_PATH =
    "M6.12494 0.899994V14.9273L1.49353 10.1636C1.15184 9.81219 0.597958 9.81219 0.256268 10.1636C-0.0854226 10.5151 -0.0854226 11.085 0.256268 11.4365L6.38132 17.7364C6.72301 18.0879 7.2771 18.0879 7.61858 17.7364L13.7436 11.4365C13.9145 11.2607 14 11.0303 14 10.7999C14 10.5698 13.9145 10.3394 13.7436 10.1636C13.4019 9.81219 12.8478 9.81219 12.5064 10.1636L7.87495 14.9273V0.899994C7.87495 0.403197 7.48317 0 6.99995 0C6.51672 0 6.12494 0.402972 6.12494 0.899994Z";

function AccordionItem({ variant = "faq", open, onToggle, question, answer }) {
    const prefix = variant === "maintenance" ? "maintenance" : "faq";

    return (
        <div className={`${prefix}-item ${open ? `${prefix}-item_active` : ""}`}>
            <div className={`${prefix}-question`} onClick={onToggle}>
                <span className={`${prefix}-question-text`}>{question}</span>
                <svg className={`${prefix}-icon`} width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d={ARROW_PATH} fill="currentColor" />
                </svg>
            </div>
            <div className={`${prefix}-answer`}>
                <p>{answer}</p>
            </div>
        </div>
    );
}

export default AccordionItem;
// components/AccordionItem/AccordionItem.js
